module.exports = __webpack_public_path__ + "img/banner05-desktop.6119ab63.webp";